import React, { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import ReactSlider from 'react-slider';
import useProductCategory from '../../hooks/useProductCategory';
import useProductList from '../../hooks/useProductList';
import { useAppConfig } from '../../context/AppConfigContext';
import { formatCurrency } from '../../constants';
import { CaretRight, Eye, TagChevron } from '@phosphor-icons/react';
import { LinkSimple, Plus } from '@phosphor-icons/react';
import useCompanyList from '../../hooks/useCompanyList';

const SearchProduct = () => {
    const { config } = useAppConfig();
    const currency = config?.currency === 'USD' ? '$' : config?.currency === 'AUD' ? 'AU$' : 'Rp';
    const [searchParams, setSearchParams] = useSearchParams();
    const keyword = searchParams.get('keyword');
    const view = searchParams.get('view');
    //console.log(keyword);

    const {
        fetchProductCategory,
        data: productCategory,
        status: productCategoryStatus,
        error: productCategoryError
    } = useProductCategory();

    const {
        fetchProductList,
        data: productList,
        total: productListTotal,
        status: productListStatus,
        error: productListError
    } = useProductList();

    const {
        fetchCompanyList,
        data: companyList,
        total: companyListTotal,
        status: companyListStatus,
        error: companyListError
    } = useCompanyList();

    let [grid, setGrid] = useState(false);
    //let [active, setActive] = useState(false);

    const [sortBy, setSortBy] = useState('name-asc');

    const [filterCategoryId, setFilterCategoryId] = useState(undefined);
    const [page, setPage] = useState(0);
    const [isLastPage, setIsLastPage] = useState(false);
    const [isFirstPage, setIsFirstPage] = useState(true);

    // useEffect(() => {
    //     fetchProductCategory();
    // }, []);

    useEffect(() => {
        fetchProductList({
            categoryIds: filterCategoryId,
            sortBy: sortBy.split('-')[0],
            sortType: sortBy.split('-')[1],
            skip: page * 20,
            take: 20,
            name: keyword ?? ''
        });
        fetchCompanyList({
            categoryIds: filterCategoryId,
            sortBy: sortBy.split('-')[0],
            sortType: sortBy.split('-')[1],
            skip: view === 'store' ? page * 20 : 0,
            take: view === 'store' ? 20 : 3,
            name: keyword ?? ''
        });
    }, [filterCategoryId, page, sortBy, keyword, view]);

    useEffect(() => {
        //console.log(productListStatus);
        if (view === 'store') {
            if (companyListStatus === 'done') {
                setIsLastPage(page + 1 === Math.ceil(companyListTotal / 20));
                setIsFirstPage(page === 0);
            }
        } else {
            if (productListStatus === 'done') {
                setIsLastPage(page + 1 === Math.ceil(productListTotal / 20));
                setIsFirstPage(page === 0);
            }
        }
    }, [productListStatus, companyListStatus, view]);

    // const setAllCategory = () => {
    //     setFilterCategoryId(undefined);
    //     setPage(0);
    // };

    // const setSelectedGallery = (id) => {
    //     setFilterCategoryId(id);
    //     setPage(0);
    // };

    // let sidebarController = () => {
    //     setActive(!active);
    // };

    // const formatCurrency = (value) => {
    //     let currencyconvertion = config?.currency === "SG" ? "SGD" : config?.currency === "AUD" ? "AU" : "IDR";
    //     let localizationconvert = config?.currency === "SG" ? "en-SG" : config?.currency === "AUD" ? "en-AU" : "en-ID";
    //     // let priceas =new Intl.NumberFormat(localizationconvert, {
    //     // 	style: "currency",
    //     // 	currency: currencyconvertion
    //     // }).format(value);
    //     // console.log("price", priceas);
    //     return new Intl.NumberFormat(localizationconvert, {
    //         style: "currency",
    //         currency: currencyconvertion
    //     }).format(value);

    // };

    return (
        <section className="shop py-80">
            {/* <div className={`side-overlay ${active && "show"}`}></div> */}
            <div className="container container-md">
                <div className="row">
                    {/* Sidebar Start */}

                    {/* Sidebar End */}
                    {/* Content Start */}

                    <div className="col-lg-12" style={{ position: 'relative' }}>
                        <div
                            style={{
                                position: 'absolute',
                                top: '0',
                                left: '0',
                                width: '100%',
                                height: '100%',
                                backgroundColor: '#fff',
                                //backgroundColor: "rgba(0, 0, 0, 0.5)",
                                zIndex: '999',
                                display: productListStatus === 'loading' ? 'block' : 'none'
                            }}
                        >
                            <img
                                src="assets/images/icon/preloader.gif"
                                style={{
                                    position: 'absolute',
                                    top: '0',
                                    left: '50%',
                                    marginTop: '100px',
                                    transform: 'translate(-50%, -50%)'
                                }}
                                alt=""
                            />
                        </div>
                        <div className="flex-between gap-16 flex-wrap mb-40 ">
                            {view === 'store' ? (
                                <>
                                    {companyListTotal > 0 ? (
                                        <>
                                            <span className="text-gray-900 text-md">
                                                Showing {page * 20 + 1}-
                                                {companyListTotal < 21
                                                    ? companyListTotal
                                                    : (page + 1) * 20 < companyListTotal
                                                      ? (page + 1) * 20
                                                      : companyListTotal}{' '}
                                                of {companyListTotal} search '<span className="text-main-one-600">{keyword}</span>' result
                                            </span>
                                            <div className="position-relative flex-align gap-16 flex-wrap">
                                               
                                                <div className="position-relative text-gray-500 flex-align gap-4 text-14">
                                                    <label htmlFor="sorting" className="text-inherit flex-shrink-0">
                                                        Sort by:{' '}
                                                    </label>
                                                    <select
                                                        defaultValue={'name-asc'}
                                                        className="form-control common-input px-14 py-14 text-inherit rounded-6 w-auto"
                                                        id="sorting"
                                                        onChange={(e) => setSortBy(e.target.value)}
                                                        style={{
                                                            minWidth: '120px'
                                                        }}
                                                    >
                                                        <option value={'name-asc'}>Name A-Z</option>
                                                        <option value={'name-desc'}>Name Z-A</option>
                                                    </select>
                                                </div>
                                                {/* <button
                                                onClick={sidebarController}
                                                type="button"
                                                className="w-44 h-44 d-lg-none d-flex flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
                                            >
                                                <i className="ph-bold ph-funnel" />
                                            </button> */}
                                            </div>
                                        </>
                                    ) : (
                                        <span className="text-gray-900">No Product Found</span>
                                    )}
                                </>
                            ) : (
                                <>
                                    {productListTotal > 0 ? (
                                        <>
                                            <span className="text-gray-900 text-md">
                                                Showing {page * 20 + 1}-
                                                {productListTotal < 21
                                                    ? productListTotal
                                                    : (page + 1) * 20 < productListTotal
                                                      ? (page + 1) * 20
                                                      : productListTotal}{' '}
                                                of {productListTotal} search '<span className="text-main-one-600">{keyword}</span>' result
                                            </span>
                                            <div className="position-relative flex-align gap-16 flex-wrap">
                                                <div className="list-grid-btns flex-align gap-16">
                                                    <button
                                                        onClick={() => setGrid(true)}
                                                        type="button"
                                                        className={`w-44 h-44 flex-center border rounded-6 text-2xl list-btn border-gray-100 ${
                                                            grid === true && 'border-main-600 text-white bg-main-one-600'
                                                        }`}
                                                    >
                                                        <i className="ph-bold ph-list-dashes" />
                                                    </button>
                                                    <button
                                                        onClick={() => setGrid(false)}
                                                        type="button"
                                                        className={`w-44 h-44 flex-center border rounded-6 text-2xl grid-btn border-gray-100 ${
                                                            grid === false && 'border-main-600 text-white bg-main-one-600'
                                                        }`}
                                                    >
                                                        <i className="ph ph-squares-four" />
                                                    </button>
                                                </div>
                                                <div className="position-relative text-gray-500 flex-align gap-4 text-14">
                                                    <label htmlFor="sorting" className="text-inherit flex-shrink-0">
                                                        Sort by:{' '}
                                                    </label>
                                                    <select
                                                        defaultValue={'name-asc'}
                                                        className="form-control common-input px-14 py-14 text-inherit rounded-6 w-auto"
                                                        id="sorting"
                                                        onChange={(e) => setSortBy(e.target.value)}
                                                    >
                                                        <option value={'name-asc'}>Name A-Z</option>
                                                        <option value={'name-desc'}>Name Z-A</option>
                                                        <option value={'price-asc'}>Lowest Price</option>
                                                        <option value={'price-desc'}>Highest Price</option>
                                                    </select>
                                                </div>
                                                {/* <button
                                                onClick={sidebarController}
                                                type="button"
                                                className="w-44 h-44 d-lg-none d-flex flex-center border border-gray-100 rounded-6 text-2xl sidebar-btn"
                                            >
                                                <i className="ph-bold ph-funnel" />
                                            </button> */}
                                            </div>
                                        </>
                                    ) : (
                                        <span className="text-gray-900">No Product Found</span>
                                    )}
                                </>
                            )}
                        </div>
                        <div className="row gy-4 mb-40">
                            {view !== 'store' && (
                                <div className="col-12 flex-align gap-8 mb-20 justify-content-end">
                                    <Link to={`/search?keyword=${keyword}&view=store`} onClick={() => setPage(0)}>
                                        View All {companyListTotal} Store <CaretRight size={16} />
                                    </Link>
                                </div>
                            )}

                            {companyList?.map((item) => (
                                <div className="col-12">
                                    <div className="border rounded-24 border-gray-300" style={{ padding: '20px' }}>
                                        <div className="d-flex  flex-wrap flex-md-nowrap justify-content-between align-items-end">
                                            <div className="d-flex flex-wrap flex-md-nowrap justify-content-center gap-16 mb-20 mb-md-0">
                                                <div
                                                    style={{
                                                        borderRadius: '50%',
                                                        overflow: 'hidden',
                                                        aspectRatio: '1 / 1',
                                                        width: '60px',
                                                        height: '60px'
                                                    }}
                                                >
                                                    <img
                                                        src={item?.logo + '?width=100' ?? '/assets/images/no-image.png'}
                                                        alt="Company Image"
                                                    />
                                                </div>
                                                <div style={{ fontFamily: 'Quicksand' }}>
                                                    <div style={{ fontWeight: '700', color: '#000', fontSize: '18px' }}>
                                                        <span>{item.businessName}</span>
                                                        <img src="assets/images/icon/verified.png" width={20} height={20} style={{ marginLeft: '6px' }} />
                                                    </div>
                                                    <div style={{ fontWeight: '500', fontSize: '14px', margin: '10px 0' }}>
                                                        <Link to={`/seller-store?storeid=${item.id}`}>
                                                            {' '}
                                                            <LinkSimple /> {item.businessName}
                                                        </Link>
                                                    </div>
                                                    {/* <div style={{ fontWeight: '500', fontSize: '12px', color: '#000000' }}>
                                                        {item.numberProduct} <span style={{ color: '#999999' }}>Products</span>
                                                    </div> */}
                                                </div>
                                            </div>
                                            <div className="d-flex   flex-wrap flex-md-nowrap gap-16 justify-content-center">
                                                <Link
                                                    to={`/seller-store?storeid=${item.id}`}
                                                    className=" "
                                                    style={{
                                                        border: '1px solid #990A02',
                                                        color: '#990A02',
                                                        borderRadius: '20px',
                                                        height: '30px',
                                                        padding: '4px 10px',
                                                        textAlign: 'center',
                                                        width: '100px',
                                                        fontSize: '12px'
                                                    }}
                                                >
                                                    Visit Store
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {view !== 'store' && (
                            <div className={`list-grid-wrapper ${grid && 'list-view'}`}>
                                {Array.isArray(productList) &&
                                    productList.length > 0 &&
                                    productList.map((item, index) => (
                                        <div
                                            key={item.id}
                                            className="product-card h-100 p-8 border border-gray-100 hover-border-main-one-600 rounded-16 position-relative transition-2"
                                        >
                                            <Link
                                                to={`/product-details/${encodeURIComponent(item.slug)}`}
                                                className="product-card__thumb flex-center rounded-8 bg-gray-50 position-relative"
                                            >
                                                {item?.discountPrice > 0 && item?.discountPrice < item?.price && (
                                                    <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                                                        Sale {Number(item?.discount)?.toFixed(0)?.toLocaleString('en-US')}%
                                                    </span>
                                                )}

                                                <img
                                                    src={
                                                        item.photoData && item.photoData.length > 0
                                                            ? item.photoData[0].url + '?width=277'
                                                            : '/assets/images/no-image.png'
                                                    }
                                                    alt=""
                                                />
                                            </Link>
                                            <div className="product-card__content w-100 mt-0">
                                                <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                                    <Link
                                                        to={`/product-details/${encodeURIComponent(item.slug)}`}
                                                        className="link text-line-2"
                                                        tabIndex={0}
                                                    >
                                                        {item.name || ''}
                                                    </Link>
                                                </h6>
                                                <div className="product-card__price my-20">
                                                    {item?.discountPrice > 0 && item?.discountPrice < item?.price && (
                                                        <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                                                            {currency}
                                                            {Number(item?.price)?.toFixed(2)?.toLocaleString('en-US')}
                                                        </span>
                                                    )}

                                                    <div className="d-flex flex-align gap-4">
                                                        <span className="text-heading text-md fw-semibold d-flex flex-grow-1">
                                                            {/* {currency}
                                                    {Number(
                                                        item?.discountPrice > 0 &&
                                                            item?.discountPrice < item?.price
                                                            ? item?.discountPrice
                                                            : item?.price
                                                    )
                                                        ?.toFixed(2)
                                                        ?.toLocaleString("en-US")}{" "} */}
                                                            {item?.discountPrice > 0 && item?.discountPrice < item?.price
                                                                ? // item?.discountPrice
                                                                  formatCurrency(item?.discountPrice)
                                                                : // item?.price
                                                                  formatCurrency(item?.price)}
                                                            <span className="text-gray-500 fw-normal">/Qty</span>{' '}
                                                        </span>
                                                        <span className="text-gray-500 fw-normal d-flex flex-align gap-4">
                                                            <Eye size={16} /> {item?.viewCount}
                                                        </span>{' '}
                                                    </div>
                                                </div>
                                                <Link
                                                    to={`/product-details/${encodeURIComponent(item.slug)}`}
                                                    className="product-card__cart btn bg-main-one-50 text-heading hover-bg-main-one-600 hover-text-white py-11 px-24 rounded-8 flex-center gap-8 fw-medium"
                                                    tabIndex={0}
                                                >
                                                    View Detail
                                                </Link>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        )}

                        {view === 'store' ? (
                            <>
                                <ul className="pagination flex-center flex-wrap gap-16">
                                    {companyListTotal > 20 && !isFirstPage && (
                                        <li className="page-item">
                                            <Link
                                                className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                                to={`/search?keyword=${keyword}&view=store`}
                                                onClick={() => setPage(page > 0 ? page - 1 : 0)}
                                            >
                                                <i className="ph-bold ph-arrow-left" />
                                            </Link>
                                        </li>
                                    )}
                                    {Array.from({ length: Math.ceil(companyListTotal / 20) }, (_, i) => (
                                        <li className={`page-item ${page === i ? 'active' : ''}`} key={i}>
                                            <Link
                                                className={`page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100 `}
                                                to={`/search?keyword=${keyword}&view=store`}
                                                onClick={() => setPage(i)}
                                            >
                                                {String(i + 1).padStart(2, '0')}
                                            </Link>
                                        </li>
                                    ))}

                                    {companyListTotal > 20 && !isLastPage && (
                                        <li className="page-item">
                                            <Link
                                                className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                                to={`/search?keyword=${keyword}&view=store`}
                                                onClick={() => setPage(page + 1)}
                                            >
                                                <i className="ph-bold ph-arrow-right" />
                                            </Link>
                                        </li>
                                    )}
                                </ul>
                            </>
                        ) : (
                            <>
                                <ul className="pagination flex-center flex-wrap gap-16">
                                    {productListTotal > 20 && !isFirstPage && (
                                        <li className="page-item">
                                            <Link
                                                className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                                to={`/search?keyword=${keyword}`}
                                                onClick={() => setPage(page > 0 ? page - 1 : 0)}
                                            >
                                                <i className="ph-bold ph-arrow-left" />
                                            </Link>
                                        </li>
                                    )}
                                    {Array.from({ length: Math.ceil(productListTotal / 20) }, (_, i) => (
                                        <li className={`page-item ${page === i ? 'active' : ''}`} key={i}>
                                            <Link
                                                className={`page-link h-64 w-64 flex-center text-md rounded-8 fw-medium text-neutral-600 border border-gray-100 `}
                                                to={`/search?keyword=${keyword}`}
                                                onClick={() => setPage(i)}
                                            >
                                                {String(i + 1).padStart(2, '0')}
                                            </Link>
                                        </li>
                                    ))}

                                    {productListTotal > 20 && !isLastPage && (
                                        <li className="page-item">
                                            <Link
                                                className="page-link h-64 w-64 flex-center text-xxl rounded-8 fw-medium text-neutral-600 border border-gray-100"
                                                to={`/search?keyword=${keyword}`}
                                                onClick={() => setPage(page + 1)}
                                            >
                                                <i className="ph-bold ph-arrow-right" />
                                            </Link>
                                        </li>
                                    )}
                                </ul>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SearchProduct;
